import { useEffect, useRef } from 'preact/hooks'
import throttle from 'lodash.throttle'
import { addClass, off, on, removeClass, select } from 'helpers/dom'
import { isLoading, isFiltering, pagination, products, selectedValues, setActiveFilters } from 'snippets/plp-native/@store'
import PlpNativeSkeletonHeader from 'snippets/plp-native/plp-native-skeleton/plp-native-skeleton-header'
import Icon from 'snippets/icon/icon'
import PlpNativeSort from 'snippets/plp-native/plp-native-sort/plp-native-sort'

const selectors = {
  HEADER_SELECTOR: 'site-header',
  PLP_GRID_SELECTOR: '.js-plp-native-grid',
  IS_STICKY: 'is-sticky'
}

function PlpNativeHeader() {
  const plpNativeHeaderRef = useRef(null)

  if (isLoading.value && !products.value?.length) {
    return (
      <div className="sticky top-[52px] left-0 right-0 z-20 flex items-center justify-between bg-white  border-b border-neutral-900 lg:top-[72px] [&.is-sticky]:fixed">
        <PlpNativeSkeletonHeader />
      </div>
    )
  }

  const getTotalFilter = () => {
    if (!Object.keys(selectedValues.value).length) return 0

    const cloneObj = { ...selectedValues.value }

    delete cloneObj['filter.v.price']
    delete cloneObj['filter.p.m.seo.hidden']

    const filtersSelected = Object.values(cloneObj).flat()

    return filtersSelected.length
  }

  const handleScroll = () => {
    on(
      'scroll',
      throttle(() => {
        if (!plpNativeHeaderRef.current) return

        const headerEl = select(selectors.HEADER_SELECTOR)
        const plpNativeGridEl = select(selectors.PLP_GRID_SELECTOR)
        const headerHeight = headerEl ? headerEl.clientHeight : 0
        const threshold = headerHeight + 35 // 35 is height of filter plp

        if (plpNativeGridEl.getBoundingClientRect().top <= threshold) {
          addClass(selectors.IS_STICKY, plpNativeHeaderRef.current)
        } else {
          removeClass(selectors.IS_STICKY, plpNativeHeaderRef.current)
        }
      }, 100),
      window
    )
  }

  useEffect(() => {
    on('scroll', throttle(handleScroll, 100), window)

    return () => off('scroll', handleScroll, window)
  }, [])

  if (!isLoading.value && !products.value?.length && !Object.keys(selectedValues.value).length) return null

  return (
    <div
      ref={plpNativeHeaderRef}
      className="sticky top-[52px] left-0 right-0 z-20 flex items-center justify-between bg-white  border-b border-neutral-900 lg:top-[72px] [&.is-sticky]:fixed"
    >
      <button
        type="button"
        onClick={() => setActiveFilters()}
        className="text-xs flex w-fit items-center justify-center gap-1.5 text-neutral-900 px-5 py-3 border-r border-neutral-900 md:px-10"
      >
        <Icon name="icon-filter" className="h-[18px] w-[18px] text-neutral-900" viewBox="0 0 20 20" />
        <span>
          {translate.collection.filters} {getTotalFilter() > 0 && `(${getTotalFilter()})`}
        </span>
      </button>
      <span className="flex-1 text-xs text-center relative block capitalize text-neutral-900">

        {isFiltering.value ? (
          <div className="h-5 w-16 bg-skeleton mx-auto animate-pulse" />
        ) : (
          <>
            {pagination.value.totalProducts} {pagination.value.totalProducts !== 1 ? 'items' : 'item'}
          </>
        )}
      </span>
      <PlpNativeSort />
    </div>
  )
}

export default PlpNativeHeader
